<div
  [ngClass]="iconClasses"
  matTooltip="{{ text }}"
  [matTooltipClass]="tooltipClasses"
>
  <mat-icon *ngIf="icon === ToolTipIcon.Info">info</mat-icon>
  <mat-icon *ngIf="icon === ToolTipIcon.Warning">error</mat-icon>
</div>
